export default __webpack_public_path__ + "static/media/card_client_sa.3a6006c8.webp";